//@flow
import { logoutApi } from "../services/logout";
import axios from "axios";
import { actions as authActions } from "../app/auth";
import { clearAllItems, getItem, setItem } from "./localStorage";
import * as Sentry from "@sentry/browser";
import { INTERCOM_BANNER_KEYS } from "./intercomConstants";

export const authTokenKey = "AUTH_TOKEN";
export const responseHeaderKeys = {
  pagination: "x-pagination",
};

const baseUrl = import.meta.env.VITE_API_V1_URL;
const apiDomain = import.meta.env.VITE_API_BASE_URL;

export const get = (request) => {
  return commonFetch({ method: "get", ...request });
};

export const post = (request) => {
  return commonFetch({ method: "post", ...request });
};

export const patch = (request) => {
  return commonFetch({ method: "patch", ...request });
};

export const put = (request) => {
  return commonFetch({ method: "put", ...request });
};

export const deletee = (request) => {
  return commonFetch({ method: "delete", ...request });
};

const commonFetch = async (request) => {
  const { subUrl, method, data = {}, params = {}, headers = {} } = request;
  const url = request.url || getFullUrl(subUrl);
  const response = await axios({
    method,
    url,
    data,
    headers: { ...headers },
    params,
  });
  if (handleResponseStatus(response)) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(response);
  }
  // don't add .catch(), othewise the reducers will not catch error like 404
};

const handleResponseStatus = (response) => {
  if (response.status >= 200 || response.status < 300) {
    return true;
  }
  return false;
};

const getFullUrl = (url) => {
  return `${baseUrl}${url}`;
};

export const getBaseUrl = () => {
  return `${baseUrl}`;
};

export const getApiDomain = () => {
  return apiDomain;
};

export const getErrorObject = (error) => {
  const errorData = error?.response?.data;

  const message =
    errorData?.message ||
    errorData?.error_description ||
    errorData?.error ||
    error?.message ||
    "Error!";

  return { message };
};

export const getBlobErrorMessage = async (error) => {
  const data = error?.response?.data;
  if (data instanceof Blob && data.type === "application/json") {
    try {
      const text = await data.text();
      const json = JSON.parse(text);
      return json.message || json.error || json.detail || null;
    } catch {
      // ignore parse errors, fall back to generic handler
    }
  }
  return null;
};

export const getErrorCode = (error) => {
  let errorCode = null;
  if (error && error.response) {
    errorCode = error.response.status;
  }
  return errorCode;
};

export const logout = async () => {
  const postObj = {
    client_id: import.meta.env.VITE_OAUTH_CLIENT_ID,
    client_secret: import.meta.env.VITE_OAUTH_CLIENT_SECRET,
    token: authActions.getAccessToken(),
  };
  try {
    await logoutApi(postObj);
    authActions.clearSession();
    cleanAndReload();
  } catch (e) {
    // catch 401 error to prevent sentry error, clear session and forward to login page
    authActions.clearSession();
    cleanAndReload();
  }
};

export function cleanAndReload() {
  cleanData();
  Sentry.setUser(null);
  setTimeout(() => {
    reload();
  }, 1000);
}

export function cleanData() {
  const isDemoData = getItem("demoData") || false; // prevent removing the demoData key

  const preservedKeys = {};
  Object.values(INTERCOM_BANNER_KEYS).forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) preservedKeys[key] = value;
  });

  clearAllItems(); // remove all localStorage items and respective redux params

  localStorage.clear();
  // MSAL (@azure/msal-browser) defaults to sessionStorage for its token cache,
  // so logout must also wipe sessionStorage or the next Entra sign-in re-hydrates
  // a stale account and fails with "Microsoft Entra authentication failed".
  sessionStorage.clear();

  if (isDemoData) {
    setItem("demoData", true);
  }

  Object.values(INTERCOM_BANNER_KEYS).forEach((key) => {
    if (preservedKeys[key]) {
      localStorage.setItem(key, preservedKeys[key]);
    }
  });

  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;

    // do not remove cookie consent
    if (name.trim() === "consent") continue;

    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

function reload() {
  //document.location.reload();
  //window.location.reload();
  window.location.replace("/login");
}
